import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
const items = [{
  title: 'Amas tu caos',
  desc: 'Prefieres seguir analizando el origen de tu problema durante años en lugar de detener el ruido ahora.'
}, {
  title: "Buscas 'Psicología de Sillón'",
  desc: 'Esto es un manual de intervención rápida de 25 láminas, no una enciclopedia teórica de 300 páginas.'
}, {
  title: 'Eres pasivo',
  desc: 'Si no estás dispuesto a dedicar 4 minutos a ejecutar una secuencia de pasos mecánicos, esto no te servirá.'
}];
export function NotForYouSection() {
  return <section className="py-24 bg-navy-800 border-t border-steel-800" data-id="element-98">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-99">
        <FadeIn data-id="element-100">
          <h2 className="text-3xl sm:text-4xl font-bold mb-16 text-center tracking-tight text-steel-500" data-id="element-101">
            ESTO NO ES PARA TI SI:
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-3 gap-6" data-id="element-102">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-103">
              <div className="flex flex-col items-center text-center gap-4 p-8 bg-navy-900/50 border border-steel-800/50 rounded-sm h-full opacity-80" data-id="element-104">
                <XCircle className="w-8 h-8 text-steel-500 shrink-0" data-id="element-105" />
                <div data-id="element-106">
                  <h3 className="text-lg font-bold text-white/80 mb-3 font-sans" data-id="element-107">
                    {item.title}
                  </h3>
                  <p className="text-sm text-offwhite/60 leading-relaxed" data-id="element-108">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}